export default __webpack_public_path__ + "static/media/redirect-select-sk.4cbf20ae.png";